class SelectFilterService {
    handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Space') {
            e.stopPropagation();
        }
    };

    handleChange =
        (setFilter: (value: string) => void, onSearch: (value: string) => void) =>
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setFilter(e.target.value);

            if (onSearch) {
                onSearch(e.target.value);
            }
        };

    handleInput =
        (filter: string, onSearch: (value: string) => void) =>
        (e: React.ClipboardEvent<HTMLInputElement>) => {
            if (onSearch && e.currentTarget.value !== filter) {
                onSearch(e.currentTarget.value);
            }
        };
}

const selectFilterService = new SelectFilterService();

export { selectFilterService as SelectFilterService };
